import instance from "@network/api";
import { RequestLogin } from "./type";
import { VERIFY_LINK_TYPE } from "@type/index";

export async function login(payload: Omit<RequestLogin, "invitedBy">) {
  // Check if there's a referral ID in localStorage
  const referralId = localStorage.getItem('referralId');
  const loginPayload = {
    ...payload,
    ...(referralId && { invitedBy: parseInt(referralId) })
  };

  const res = await instance.post("/auth/login-by-phone", loginPayload);

  // Clear the referral ID after successful login
  if (referralId) {
    localStorage.removeItem('referralId');
  }

  return res.data;
}

export async function verify(payload: RequestLogin) {
  // Check if there's a referral ID in localStorage
  const referralId = localStorage.getItem('referralId');
  const verifyPayload = {
    ...payload,
    ...(referralId && { invitedBy: parseInt(referralId) })
  };

  const res = await instance.post("/auth/verify-login-otp", verifyPayload);

  // Clear the referral ID after successful verification
  if (referralId) {
    localStorage.removeItem('referralId');
  }

  return res.data;
}

export async function verifyLink({
  token,
  type,
}: {
  token: string;
  type: VERIFY_LINK_TYPE;
}) {
  const res = await instance.post("/auth/verify-link", { token, type });
  return res.data;
}

export async function reverifiedEmail(payload: {
  email: string;
  name: string;
  userId: number;
}) {
  const res = await instance.post("/auth/send-verification-link", payload);
  return res.data;
}
export interface ConnectReferralResponse {
  success: boolean;
  message: string;
  userTicketId: number;
  referralTicketId: number;
}

export async function connectReferral(referralId: number): Promise<ConnectReferralResponse> {
  const res = await instance.post("/referral/connect", { referralId });
  return res.data.data;
}
